import useTitle from 'hooks/useTitle';
import React, { useCallback, useMemo } from 'react';
import * as AccessModels from 'models/access';
import useLoading from 'hooks/useLoading';
import usePromise from 'hooks/usePromise';
import CreateAccess from 'models/access/createAccess';
import AccessResource from 'models/access/resource';
import ContentLoading from 'components/ContentLoading';
import AccessContext from './Context';
import AccessTable from './Table';

export const AllAccesses = () => {
  useTitle('DigiTach: Sikrede adgange');

  // eslint-disable-next-line max-len
  const callback = useCallback(async (signal: AbortSignal) => (await AccessModels.api.List(signal)).data, []);
  const [loading, setLoading] = useLoading();
  const [values, setValues] = usePromise(callback, [], setLoading);

  const createAccess = useCallback(async (binding: CreateAccess) => {
    const result = await AccessModels.api.Create(binding);

    setValues((prev) => [...prev, result.data]);
  }, []);

  const deleteAccess = useCallback(async (resource: AccessResource) => {
    await AccessModels.api.Delete(resource.token);
    setValues((prev) => prev.filter((a) => a.token !== resource.token));
  }, []);

  const contextValue = useMemo(() => ({
    createAccess,
    deleteAccess,
  }), [createAccess, deleteAccess]);

  return (
    <AccessContext.Provider value={contextValue}>
      <ContentLoading loading={loading}>
        <AccessTable values={values} />
      </ContentLoading>
    </AccessContext.Provider>
  );
};

export default AllAccesses;
